import React from "react";
import { Col, Container, Row, Nav } from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import ContentWrapper from "../ContentWrapper/ContentWrapper";
import TableWrapper from "../TableWrapper/TableWrapper";
import headerStyles from "./scss/header.module.scss";
import SearchBar from "./SearchBar";

const Header = () => {
  return (
    <div>
      <header className={headerStyles.header}>
        <Container>
          <Row>
            <Col md="auto">
              {/* <!-- logo --> */}
              <Link to="/">
                {" "}
                <div className={headerStyles.logo}>
                  {/* <Link to="/"> */}
                  <img src="/img/NftAgg1.png" alt="Cross Tower" width={`200`} />
                  {/* </Link> */}
                  <img src="/img/nft.png" alt="NFT Aggregator" />
                </div>
              </Link>
            </Col>
            <Col className="d-flex w-100 justify-content-end align-items-center">
              <SearchBar />
              <div className="d-inline-flex">
                {/* <Nav.Item> */}
                <Nav.Link
                  as={NavLink}
                  to="/fan-token"
                  className={headerStyles.link}
                  activeClassName={`${headerStyles.link} ${headerStyles.customActive}`}
                >
                  Fan Token
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/nft"
                  className={headerStyles.link}
                  activeClassName={` ${headerStyles.customActive}`}
                >
                  NFT's
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/request"
                  className={headerStyles.link}
                  activeClassName={` ${headerStyles.customActive}`}
                >
                  NFT collection
                </Nav.Link>
              </div>
              {/* <div className="d-inline-flex">
                <a className={headerStyles.btn} href="">
                  Connect to Wallet
                </a>
              </div> */}
            </Col>
          </Row>
        </Container>
      </header>
    </div>
  );
};

export default React.memo(Header);
